import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { BaseService } from 'src/app/services/common/base.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { first, shareReplay } from 'rxjs';
import { DatePipe } from '@angular/common';
import saveAs from 'file-saver';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-over-flow-pond',
  templateUrl: './over-flow-pond.component.html',
  styleUrls: ['./over-flow-pond.component.scss'],
  providers: [DatePipe]
})
export class OverFlowPondComponent implements OnInit {

  @ViewChild('overFlowPondTable', { static: true })
  public overFlowPondTable: Table;

  public userId: any;
  public overFlowPondMasterData: any = [];
  public loading: boolean = false;
  public showDialogToUpdateStatus: any = false;
  public ipAddress: any;
  public isSubmitted: boolean = false;
  public subscriptions: any = []
  public updateStatusForm: FormGroup;
  public subjectSub: any;
  public selectedYear: any;
  public selectedCrop: any;
  public product: any;
  public selectedOverFlowPond: any;
  public showDialogToAddCanal: boolean = false;
  public addCanalForm: FormGroup;
  public selectedVillage: any;
  public filteredVillage: any = [];
  public addCanalSubmitted: boolean = false;
  public villageList: any = [];
  public outletMasterData = [];
  menuItems: MenuItem[];
  appVerificationItems: MenuItem[];
  
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];

  constructor(
    private service: BaseService,
    private activityRecordService: ActivityRecordService,
    private deptDashBoardService: DepartmentDashboardService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private loader: AppLoaderService,
    private ipService: IpAddressService,
    private _personalDetalSer: FarmersDetailsService,
    private _fb: FormBuilder,
    private datePipe: DatePipe,
    private cryptoJsService: CryptoJsService,
  ) { }

  ngOnInit(): void {
    this.getIP();
    this.loadDataAndApplyFilter();
    this.menuItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.overFlowPondMasterData, "Over Flow Pond Master Data");
        }
      },
      // {
      //   label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
      //     this.downloadSheetAsPdf(this.overFlowPondMasterData, "Over Flow Pond Master Data Master Report");
      //   }
      // },
    ];

    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.overFlowPondMasterData, "Over Flow Pond Master Data");
        }
      },
      // {
      //   label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
      //     this.downloadSheetAsPdf(this.overFlowPondMasterData, "Over Flow Pond Master Data");
      //   }
      // },
    ];
    // console.log(this.overFlowPondMasterData);
    // console.log(this.overFlowPondMasterData.length);

    this.updateStatusForm = this._fb.group({
      documentID: ['', Validators.required],     
      documentPath: ['', Validators.required],
      fromDate: ['', Validators.required],
      endDate: ['', Validators.required],
      area: ['', Validators.required],
    });

    this.addCanalForm = this._fb.group({
      outlet: ['', [Validators.required]],
      village: [, [Validators.required]],
      cca: [, [Validators.required]],
    });

    this.getVillageData();

  }

  get updateStatusFormControls() {
    return this.updateStatusForm.controls;
  }

  // ngOnDestroy(){
  //   this.subscriptions.forEach(sub => sub.unsubscribe());
  //   if(this.subjectSub){
  //     this.subjectSub.unsubscribe();
  //   }
  // }

  loadDataAndApplyFilter() {
    if (sessionStorage.getItem('financialYear')) {
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))
    }

    this.subjectSub = this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {


        this.selectedYear = res;
        this.loadData();
        // this.cropMasterTable.filters['FinYear'] = [
        //   { value: this.selectedYear, matchMode: 'startsWith', operator: 'and' },];
      }
    );
  }

  // get updateStatusFormControls() {
  //   return this.updateStatusForm.controls;
  // }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress', JSON.stringify(this.ipAddress));
      });
    }
  }

  loadData() {
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));    
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;
    // this.vendorRegId = JSON.stringify(token?.officeCode);

    // this.loader.start();
    this.loading = true;
    let sub = this.deptDashBoardService
      .getOverflowPondMaster()
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.activityRecordService.activityRecord(this.userId, 'Update Overflow Pond Status', '', new Date(), 'Success');

          this.userId = JSON.parse(payload)?.sub;


          if (data.length > 0) {
            this.overFlowPondMasterData = data;
          }
          else {
            this.overFlowPondMasterData = [];
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
          }
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
          this.activityRecordService.activityRecord(this.userId, 'Update Crop Status', '', new Date(), err);

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  addCanalDetails(){
    this.showDialogToAddCanal = true;
  }

  hideAddDialog(){
    this.showDialogToAddCanal = false;
    this.selectedVillage = {};
    this.addCanalSubmitted = false;
    this.addCanalForm.reset();
    this.outletMasterData = [];
  }


  onAddSubmit(){
    this.addCanalSubmitted = true;
    if (this.addCanalForm.invalid) {
      return;
    }else{
      let val = this.addCanalForm.value;
      let reqBody = {
        "recordId": val.outlet.recordID,
        "type": 1,
        "cca": val.cca,
        "villageCode": this.selectedVillage?.Code,
        "netWork_Id": this.ipAddress,
        "terminal_Id": this.ipAddress
      }

      this.submitOutletToTarget(reqBody);
    }
  }

  submitOutletToTarget(reqBody){
    this.loader.start();
    this.deptDashBoardService
      .addOverFlowPondToTarget(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.loadData();
          if(data == "Status updated Successfully"){
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: data,
            });
          }else{
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: data,
            });
          }
          
          this.hideAddDialog();
          this.activityRecordService.activityRecord(this.userId, 'Add Overflow Pond', '', new Date(), 'Success', reqBody);
        },
        error: (err) => {
          this.loader.close();
          this.activityRecordService.activityRecord(this.userId, 'Add Overflow Pond', '', new Date(), err, reqBody);

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }
  

  get f() {
    return this.addCanalForm.controls;
  }

  filterVillage(event: any) {
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.villageList.length; i++) {
      const village = this.villageList[i];
      if (village.Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(village);
      }
    }

    this.filteredVillage = filtered;
  }

  getVillageData() {
    // this.loader.start();
    this.loading = true;
    this._personalDetalSer.getVillageMatserData().subscribe(res => {
      // this.loader.close();
      this.loading = false;
      // console.log(res);
      this.villageList = res;
      this.filteredVillage = [...this.villageList]
      if(!window.sessionStorage.getItem("villageMaster")){
        window.sessionStorage.setItem("villageMaster", JSON.stringify(res));
      }
    })
  }

  onSelectVillage(){
    this.f.outlet.reset();
    this.getOutletsForTarget(this.selectedVillage.Code);
  }

  updateAction(val){
    this.showDialogToUpdateStatus = true;
    this.selectedOverFlowPond = val;
  }

  saveProduct() {
    if (this.updateStatusForm.valid) {
      let val = this.updateStatusForm.value;
      let reqBody = {
        AutoId: this.selectedOverFlowPond?.AutoID,
        Status: this.selectedOverFlowPond?.Status == 'Open' ? 0 : 1,
        documentPath: val?.documentPath,
        documentID: val?.documentID,
        fromDate: val.fromDate ? this.datePipe.transform(new Date(val.fromDate), 'yyyy-MM-dd') : val.fromDate,
        endDate: val.endDate ? this.datePipe.transform(new Date(val.endDate), 'yyyy-MM-dd') : val.endDate,
        area: val?.area,
        NetworkId: this.ipAddress,
        TerminalId: this.ipAddress
      }
      this.updateOverFLowPondStatus(reqBody);
    }
  }

  updateOverFLowPondStatus(reqBody) {
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));    
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    this.loader.start();
    this.deptDashBoardService
      .updateOverFLowPondTargetStatus(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.loadData();
          this.messageService.add({
            severity: 'success',
            summary: 'Success Message',
            detail: 'Status Updated Succesfully',
          });
          this.hideUpdateDialog();
          this.activityRecordService.activityRecord(this.userId, 'Update OverFlow Status', reqBody?.Auto_ID, new Date(), 'Success', reqBody);
        },
        error: (err) => {
          this.loader.close();
          this.activityRecordService.activityRecord(this.userId, 'Update OverFlow Status', reqBody?.Auto_ID, new Date(), err, reqBody);

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  hideUpdateDialog(){
    this.showDialogToUpdateStatus = false;
    this.isSubmitted = false;
    this.updateStatusForm.reset();
  }

  onUpload(event, formcontrol, uploadElement) {
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);
    this.loader.start();
    this._personalDetalSer.uploadFile(data, this.userId, formcontrol).subscribe(
      (resp: any) => {
        this.loader.close();
        if (resp.statusCode == 200) {
          this.updateStatusForm.patchValue({ [formcontrol]: resp.data });
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'File Uploaded with Auto Mode',
          });
        }else{
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Oops! Someting went wrong.',
          });
        }
      },
      (err) => {
        this.loader.close();
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: err,
        });
      }
    );

    uploadElement.clear();
  }

  getOutletsForTarget(villageCode){
    this.loader.start();
    this.deptDashBoardService
      .getOutletsForTarget(villageCode)
      .pipe(first())
      .subscribe({
        next: (data) => {
          data = data.map(row => ({
            ...row,
            canal_RD: `${row?.Canal} (${row?.RD})`
          }))
          this.outletMasterData = data;
          this.loader.close();
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      { field: 'TotalApps', header: 'Total Apps' },
      { field: 'Constituency', header: 'Constituency' },
      { field: 'Block', header: 'Block' },
      { field: 'District', header: 'District' },
      { field: 'Village', header: 'Village' },
      { field: 'Name', header: 'Overflow Pond Name' },
      { field: 'CCA', header: 'CCA' },
      { field: 'documentID', header: 'Document ID' },
      { field: 'Created_Date', header: 'Created Date' },
      { field: 'Updated_Date', header: 'Updated Date' },
      { field: 'fromDate', header: 'Start Date' },
      { field: 'endDate', header: 'End Date' },
      { field: 'AreaAcre', header: 'Target Area' },
      { field: 'CurrentStatus', header: 'Current Status' },
    ];

    this.exportColumns = this.cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
    }));

    import('jspdf').then((jsPDF) => {
      import('jspdf-autotable').then((x) => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, this.overFlowPondMasterData);
        doc.save('Applications_Details.pdf');
      });
    });
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          "Total Apps":d.TotalApps,
          "Constituency":d.Constituency,
          "Block":d.Block,
          "District":d.District,
          "Village":d.Village,
          "Overflow Pond Name":d.Name,
          "CCA":d.CCA,
          "Document ID":d.documentID,  
          "Created Date":d.Created_Date,
          "Updated Date":d.Updated_Date,
          "Start date":d.fromDate,  
          "End Date":d.endDate, 
          "Target Area":d.AreaAcre,
          "Current Status":d.CurrentStatus,    

        }
      })
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  refreshTable() {
    this.loadData();
  }
}



